export default __webpack_public_path__ + "static/media/prestashop-1-7.3167b795.jpg";